import { mdiChevronLeft, mdiMinusCircle, mdiRefresh } from '@mdi/js'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        delete: mdiMinusCircle,
        refresh: mdiRefresh
      }
    }
  },

  computed: {
    ...mapState({
      stops: state => state.stop.list,
      retails: state => state.options.retail_places,
      fetchingRetails: state => state.options.fetching_retail_places,
      accommodations: state => state.accommodation.list,
      fetchingAccommodations: state => state.accommodation.fetchingList
    })
  },

  methods: {
    ...mapActions({
      getRetailPlaces: 'options/getRetailPlaces',
      getAllStops: 'stop/getAllStops',
      getAllAccommodations: 'accommodation/getAllAccommodations'
    })
  }
}
